export const duplicateContentUrlsSelector = (state) => state.get('duplicateContentUrls').get('urls');
